// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as RefreshComponent} from './Refresh.svg';

import Icon, { TIconProps } from '../Icon';

export const IconRefresh = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <RefreshComponent/>
  </Icon>
));
